<template>
    <div style="background-color: #fafafa;">
		<van-pull-refresh style="margin-top: 0" v-model="refreshing" @refresh="onRefresh">
			<van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
				<div style="width: 100%;" v-for="(item, index) in list" class="card" :key="item.uuid">
					<table class="layout" style="width: 100%;" @click="openDetail(item.uuid, item.contractNumber)">
						<tr style="width: 100%;">
							<td style="width: 60%;" >
								<div class="header">
									<span class="title">{{item.contractNumber}}</span>
								</div>
							</td>
							<td style="width: 40%;text-align: left;">
								<div style="width: 100%;">
									<span style="color: red;font-weight: bold;">{{item.orderStatusname}}</span>
								</div>
							</td>
						</tr>
						<tr style="width: 100%;">
							<td colspan="2" class="content" style="width: 100%;">
								<p><span>收货人：</span><span>{{item.customerName}}</span></p>
								<p><span>联系方式：</span><span>{{item.arrivalMobile}}</span></p>
								<p><span>收货地址：</span><span>{{item.arrivalAddress}}</span></p>
								<p><span>备注：</span><span>{{item.remark}}</span></p>
							</td>
						</tr>
						<tr style="width: 100%;">
							<td class="content" style="width: 50%;">
								<p><span>下单人:</span><span>{{item.creatorIdname}}</span></p>
								<p><span>{{item.createTime}}</span></p>
							</td>
							<td class="content" style="width: 50%;font-size: 15px;">
								<p><span>共{{item.mainQuantities}}组,合计:</span></p>
								<p><span>¥{{item.amount}}</span></p>
							</td>
						</tr>
						<tr style="width: 100%;">
							<td class="content" colspan="2">
								<p><span>物流信息:</span><span>{{item.deliveryInfo}}</span></p>
							</td>
						</tr>
					</table>
				</div>
			</van-list>
		</van-pull-refresh>
    </div>
</template>

<script>
	import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar, Icon, Toast, Dialog} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
	import VanFieldAcb from '../../components/VanFieldAcb';
	import VanFieldDate from "../../components/VantFieldDate";
    import {formatDictionary} from "../../utils/dictionary";
	import moment from "moment";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				dealerId: "",
				creatorId: "",
				status: "",
				startTime: "",
				endTime: ""
            }
        },
      
        components: {
			VanFieldAcb,
			VanFieldDate,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
			[NavBar.name]: NavBar,
        },
		created: async function () {
			this.dealerId = this.$route.query.dealerId || "";
			this.creatorId = this.$route.query.creatorId || "";
			this.status = this.$route.query.status || "";
			this.startTime = this.$route.query.startTime || "";
			this.endTime = this.$route.query.endTime || "";
		},
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await dealerOrderService.getMyDealerRankOrderList(this.pageIndex, this.dealerId, this.creatorId, this.startTime, this.endTime, this.status);
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
				resp.data.Data.data.forEach(item => {
					item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm');
					if(item.deliveryInfo && item.deliveryInfo.length > 22){
						let temp = item.deliveryInfo;
						item.deliveryInfo = temp.substring(0, 22);
						item.deliveryInfo += "...";
					}
					if(item.remark && item.remark.length > 22){
						let temp = item.remark;
						item.remark = temp.substring(0, 22);
						item.remark += "...";
					}
					if(this.status === "2"){
						item.orderStatusname = "已出库";
					}
				});
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			openDetail(orderId, serialNumber){
				this.$router.push({path:"/rad/dealerRank/orderDetail",
					 			   query:{
										uuid: orderId,
									    serialNumber: serialNumber,
									    tableName: this.status === "2" ? "vsheet_rad_delivery" : "vsheet_rad_dealer_order"}} );
			}
        }
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		overflow: hidden;

	}
	.searchBox {
		height: 3rem;
		box-sizing: border-box;
		margin-bottom: 2rem;
		top: 0;
		position:fixed;
		width: 100%;
		background-color: #2D7FC7;
		z-index:999;
	}
</style>